export default "assets/images/icons/train-0cf72620.svg";